
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
a, .default, ::slotted(a) {
  font-family: DM Sans, Inter var, Helvetica, Arial, sans-serif;
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  color:var(--brand-primary-2);
}

a:hover,
.default:hover,
::slotted(a:hover){
  text-decoration:underline !important;
  color:var(--brand-primary-1);
}

a:focus,
.default:focus,
::slotted(a:focus){
  color:var(--brand-primary-1) !important;
}

.cta,
.cta:hover,
.cta::slotted(*),
.cta::slotted(a),
.cta::slotted(*:focus),
.cta::slotted(*:hover),
.cta-alt-2,
.cta-alt-2::slotted(*),
.cta-alt-2::slotted(a),
.cta-alt-2::slotted(*:focus){
  color:var(--gray-800) !important;
  text-decoration:none !important;
}

.cta-alt,
.cta-slot-alt,
.cta-alt:hover,
.cta-alt-2:hover,
.cta-alt-2.hover,
.cta-slot-alt:hover,
.cta-slot-alt2:hover,
.cta-slot-alt2.hover{
  text-decoration:none !important;
  color:var(--brand-neutral-white) !important;
}

.cta-slot::slotted(outline-icon),
.cta-slot-alt::slotted(outline-icon),
.cta-slot-alt-2::slotted(outline-icon),
.cta-alt > outline-icon,
.cta-alt-2 > outline-icon,
.cta > outline-icon{
  padding-left:0.5rem;
}

.cta-slot--left::slotted(outline-icon),
.cta--left > outline-icon{
  padding-left:0;
  padding-right:0.5rem;
}

.cta,
.cta-alt,
.cta-alt-2,
.cta-slot::slotted(outline-icon),
.cta-slot-alt::slotted(outline-icon),
.cta-slot-alt-2::slotted(outline-icon),
.cta > outline-icon,
.cta-alt > outline-icon,
.cta-alt-2 > outline-icon{
  display:flex;
  transition:200ms;
}

.cta-slot-alt,
.cta-slot-alt-2,
.cta-slot,
.cta-alt,
.cta-alt-2,
.cta{
  display:flex;
  position:relative;
  align-items:center;
  width:-moz-fit-content;
  width:fit-content;
  height:-moz-fit-content;
  height:fit-content;
  text-decoration:none !important;
  -webkit-text-decoration-line:none !important;
          text-decoration-line:none !important;
  transition:200ms;
}

.cta,
.cta-slot,
.cta-slot::slotted(*),
.cta::slotted(*){
  color:var(--gray-800) !important;
}

@media (min-width: 1024px){

.large{
    font-size:var(--fs-3xl);
    line-height:var(--lh-2xl)
}
  }

@media (max-width: 1023px){

.large{
    font-size:var(--fs-3xl-mobile);
    line-height:var(--lh-2xl-mobile)
}
  }

@media (min-width: 1024px){

.medium{
    font-size:var(--fs-lg);
    line-height:var(--lh-lg)
}
  }

@media (max-width: 1023px){

.medium{
    font-size:var(--fs-lg-mobile);
    line-height:var(--lh-lg-mobile)
}
  }

@media (min-width: 1024px){

.small{
    font-size:var(--fs-base);
    line-height:var(--lh-base)
}
  }

@media (max-width: 1023px){

.small{
    font-size:var(--fs-base-mobile);
    line-height:var(--lh-base-mobile)
}
  }

.tag,
.tag::slotted(a),
.cta-slot::slotted(a),
.cta::slotted(a),
.cta-slot-alt::slotted(a),
.cta-slot-alt-2::slotted(a),
.cta-alt::slotted(a),
.cta-alt-2::slotted(a){
  text-decoration:none !important;
}

.cta-slot-alt::before,
.cta-slot-alt-2::before,
.cta-slot::before,
.cta-alt::before,
.cta-alt-2::before,
.cta::before{
  content:'';
  transition:200ms;
  position:absolute;
  width:0;
  height:4px;
  top:100%;
  left:0;
  margin-top:0.25rem;
}

@media (max-width: 767px){

.cta-slot-alt::before,
.cta-slot-alt-2::before,
.cta-slot::before,
.cta-alt::before,
.cta-alt-2::before,
.cta::before{
    margin-top:0.12rem
}
  }

.cta--left::before,
.cta-slot--left::before{
  left:auto;
  right:0;
}

.cta-slot::before,
.cta::before{
  background:var(--brand-primary-2);
}

.cta-slot-alt::before,
.cta-slot-alt-2::before,
.cta-alt::before,
.cta-alt-2::before{
  background:var(--brand-secondary-1);
}

.cta-slot-alt-2:hover::before,
.cta-slot:hover::before,
.cta-alt:hover::before,
.cta-alt-2:hover::before,
.cta:hover::before,
.cta-alt.hover::before,
.cta-alt-2.hover::before,
.cta.hover::before{
  width:100%;
}

.cta-slot-alt:hover::slotted(outline-icon),
.cta-slot-alt-2:hover::slotted(outline-icon),
.cta-slot:hover::slotted(outline-icon),
.cta-alt:hover > outline-icon,
.cta-alt-2:hover > outline-icon,
.cta:hover > outline-icon,
.cta-alt.hover > outline-icon,
.cta-alt-2.hover > outline-icon,
.cta.hover > outline-icon{
  transform:translateX(1rem);
}

.cta-slot--left:hover::slotted(outline-icon),
.cta--left:hover > outline-icon,
.cta--left.hover > outline-icon{
  transform:translateX(-1rem);
}

.cta-alt:focus,
.cta-slot-alt:focus,
.cta-slot-alt::slotted(a:focus){
  color:var(--brand-neutral-white) !important;
}

.cta-slot-alt::slotted(a:focus){
  outline:2px solid var(--brand-neutral-white) !important;
}

.cta-slot-alt:focus-visible,
.cta-alt:focus-visible{
  outline:none !important;
}

.cta-slot-alt::slotted(a:focus::after),
.cta-alt:focus-visible::after{
  content:'';
  display:flex;
  width:calc(100% + 1rem);
  height:calc(100%);
  outline:white solid 2px !important;
  position:absolute;
  top:0;
  left:0;
}

.cta-alt:focus::after,
.cta-slot-alt:focus::after{
  content:'';
  display:flex;
  width:calc(100% + 1rem);
  height:calc(100%);
  outline:white solid 2px !important;
  position:absolute;
  top:0;
  left:0;
}

.cta-slot::slotted(a:focus){
  outline:var(--brand-primary-1) solid 2px;
}

.tag{
  display:flex;
  position:relative;
  width:-moz-fit-content;
  width:fit-content;
  border:1px solid var(--brand-primary-2);
  background:var(--brand-primary-2);
  padding:0.25rem 1rem;
  color:var(--brand-neutral-white);
  -webkit-text-decoration-line:none !important;
          text-decoration-line:none !important;
}

.tag:hover{
    background:var(--brand-neutral-white);
    color:var(--brand-primary-2) !important;
    text-decoration:none !important;
    cursor:pointer;
  }

.tag:focus{
    border:none;
    background:var(--brand-primary-2);
    color:var(--brand-neutral-white) !important;
    outline:2px solid transparent;
    outline-offset:2px;
  }

.tag:focus::after{
    display:flex;
    content:'';
    position:absolute;
    padding:0.25rem;
    border:2px solid var(--brand-primary-2);
    width:calc(100% + 6px);
    height:calc(100% + 6px);
    left:-3px;
    top:-3px;
  }

.tag:active{
    background-color:var(--brand-neutral-gray-900) !important;
    border:2px solid var(--brand-neutral-gray-900) !important;
    color:var(--brand-neutral-white) !important;
  }

.tag:active::after{
      display:none;
    }

.tag::slotted(a:focus){
    border:none;
    position:relative;
    -webkit-text-decoration-line:none !important;
            text-decoration-line:none !important;
    color:var(--brand-neutral-white) !important;
    outline:2px solid transparent;
    outline-offset:2px;
  }

.tag::slotted(a:focus)::after{
      display:flex;
      content:'';
      position:absolute;
      padding:0.25rem;
      border:2px solid var(--brand-primary-2) !important;
      width:calc(100% + 40px);
      height:calc(100% + 16px);
      left:-20px;
      top:-8px;
    }

.tag::slotted(a:hover){
    color:var(--brand-primary-2) !important;
    text-decoration:none !important;
  }

.tag::slotted(a:active){
    color:var(--brand-neutral-white) !important;
  }

.tag::slotted(a:active)::after{
      display:none;
    }
`;